import { render, staticRenderFns } from "./edi-link-form.vue?vue&type=template&id=6e72ea62&scoped=true&"
import script from "./edi-link-form.vue?vue&type=script&lang=ts&"
export * from "./edi-link-form.vue?vue&type=script&lang=ts&"
import style0 from "./edi-link-form.vue?vue&type=style&index=0&id=6e72ea62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e72ea62",
  null
  
)

export default component.exports